exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".g6a0d-PlA0G3REjbwiu9a div {\n  min-height: auto;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n._3Fx_713asbyspvLuNIOwUt div {\n  min-height: 28px;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n._3Fx_713asbyspvLuNIOwUt input {\n  font-size: 1rem;\n}\n._1IFP2yDUKjZroY49A_wwri {\n  cursor: pointer;\n  display: inline-block;\n  position: absolute;\n  transform: translate(4px, -1px);\n}\n._1IFP2yDUKjZroY49A_wwri._1FK9PmlmbJpqvUROApzUeP {\n  transform: translate(10px, -1px);\n}\n", ""]);
// Exports
exports.locals = {
	"formItem": "g6a0d-PlA0G3REjbwiu9a",
	"formItemText": "_3Fx_713asbyspvLuNIOwUt",
	"iconTooltip": "_1IFP2yDUKjZroY49A_wwri",
	"moreMargin": "_1FK9PmlmbJpqvUROApzUeP"
};